export default __webpack_public_path__ + "static/media/logo-geodatin.002a79d1.png";